import { useLeaderboard, useMe } from "../api/hooks";
import { Card, Empty, ErrorNote, Pill, Skeleton } from "../components/ui";
import { gxr } from "../lib/format";

export function LeaderboardScreen() {
  const q = useLeaderboard();
  const me = useMe();

  if (q.isPending) return <Skeleton className="h-64" />;
  if (q.isError) return <ErrorNote>Could not load the leaderboard.</ErrorNote>;

  const myRank = me.data?.rank ?? null;
  const myName = me.data?.username ? `@${me.data.username}` : null;

  return (
    <div className="space-y-3">
      {me.data && (
        <Card>
          <div className="flex items-center justify-between text-sm">
            <span className="text-hint">Your rank</span>
            <span className="text-lg font-semibold">{myRank ? `#${myRank}` : "—"}</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-hint">Your balance</span>
            <span className="tabular-nums">{gxr(me.data.balance)} GXR</span>
          </div>
        </Card>
      )}

      <Card title="Top miners">
        {q.data.entries.length === 0 ? (
          <Empty>No claims yet.</Empty>
        ) : (
          <ol className="divide-y divide-white/5">
            {q.data.entries.map((e) => {
              const isMe = myName !== null && e.displayName === myName;
              return (
                <li
                  key={e.rank}
                  className={`flex items-center gap-3 py-2 text-sm ${isMe ? "text-brand" : ""}`}
                >
                  <span className="w-7 text-right tabular-nums text-hint">{e.rank}</span>
                  <span className="flex-1 truncate font-medium">{e.displayName}</span>
                  {e.streak >= 7 && <Pill tone="brand">{e.streak}d</Pill>}
                  <span className="tabular-nums">{gxr(e.balance)}</span>
                </li>
              );
            })}
          </ol>
        )}
        <p className="mt-3 text-xs text-hint">
          Updated every minute. Final standings are published after the season snapshot.
        </p>
      </Card>
    </div>
  );
}
